module.exports = "/_next/static/images/window_restore_mac-53659513e27b7c47444d5ccb951e1d3c.svg";